module.exports = __webpack_public_path__ + "static/media/CC-COL11_1Da6CBQXvEf03sEZIAJ83TvcmX9kYKQEn.3d72a0fd.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/CC-COL11_1Da6CBQXvEf03sEZIAJ83TvcmX9kYKQEn
// module id = 770
// module chunks = 0